import Component from "@tunnel-components/@sharded/modal/healthCheck/component";
import * as React from "react";

class Container extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public onSubmit = (event: any) => {
    const ENV = "check";
    if (!this.props.message) {
      window.document.location.href = window[ENV].FRONT_URL_FALLBACK;
    }
  };

  public render() {
    return (
      <Component {...this.state} {...this.props} onSubmit={this.onSubmit} />
    );
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/healthCheck/container.tsx